var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('Header',{attrs:{"URL":_vm.URL,"loggedIn":_vm.loggedIn},on:{"logout":_vm.logout}}),_c('router-view',{on:{"loggedIn":function($event){return _vm.login($event)}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }